import { defineMessages } from 'react-intl';

export const agentTodoMessages = defineMessages({
  creatingTodo: {
    defaultMessage: '{count, plural, one {Creating Todo} other {Creating Todos}}…',
    id: 'gsny8atcEy',
    description: 'Running header when the agent creates one or more todos',
  },
  settingTodo: {
    defaultMessage:
      '{count, plural, =0 {Setting todo list} one {Setting Todo} other {Setting Todos}}…',
    id: 'FI71GHZTyq',
    description: 'Running header when the agent sets a todo or the full todo list',
  },
  updatingTodo: {
    defaultMessage: '{count, plural, one {Updating Todo} other {Updating Todos}}…',
    id: 'Z5qBGAxBaH',
    description: 'Running header when the agent updates one or more todos',
  },
  completingTodo: {
    defaultMessage: '{count, plural, one {Completing Todo} other {Completing Todos}}…',
    id: 'YDTLHXZE2u',
    description: 'Running header when the agent completes one or more todos',
  },
  deletingTodo: {
    defaultMessage: '{count, plural, one {Deleting Todo} other {Deleting Todos}}…',
    id: 'grVp4NEQyx',
    description: 'Running header when the agent deletes one or more todos',
  },
  gettingTodo: {
    defaultMessage:
      '{count, plural, =0 {Getting todo list} one {Getting Todo} other {Getting Todos}}…',
    id: 'y2AeECwTNs',
    description: 'Running header when the agent fetches todos or the full todo list',
  },
  createTodo: {
    defaultMessage: '{count, plural, one {Create Todo} other {Create Todos}}',
    id: 'F7gJ8e7v7E',
    description: 'Completed header when the agent created one or more todos',
  },
  setTodo: {
    defaultMessage:
      '{count, plural, =0 {Set todo list} one {Set Todo} other {Set Todos}}',
    id: '8AP5vP+JIG',
    description: 'Completed header when the agent set a todo or the full todo list',
  },
  updateTodo: {
    defaultMessage: '{count, plural, one {Update Todo} other {Update Todos}}',
    id: 'vmxKX0xkEn',
    description: 'Completed header when the agent updated one or more todos',
  },
  completeTodo: {
    defaultMessage: '{count, plural, one {Complete Todo} other {Complete Todos}}',
    id: 'Gg1v4iVPur',
    description: 'Completed header when the agent completed one or more todos',
  },
  deleteTodo: {
    defaultMessage: '{count, plural, one {Delete Todo} other {Delete Todos}}',
    id: 'mIhYwjh/ia',
    description: 'Completed header when the agent deleted one or more todos',
  },
  getTodo: {
    defaultMessage:
      '{count, plural, =0 {Get todo list} one {Get Todo} other {Get Todos}}',
    id: 'GmM8kvnfEN',
    description: 'Completed header when the agent fetched todos or the full todo list',
  },
  operationFailed: {
    id: 'JRabiiwj6L',
    defaultMessage: '{title} failed',
    description: 'Failed header suffix for a todo tool operation',
  },
  allAssignedStepsComplete: {
    id: 'XI/uggqXzF',
    defaultMessage: 'All assigned steps are complete',
    description: 'Subtitle when every todo step is finished',
  },
  todoListCleared: {
    id: 'qWThE5KTkT',
    defaultMessage: 'Todo list cleared',
    description: 'Subtitle when the todo list was cleared',
  },
  todoListEmpty: {
    id: '4Au1G2CkGu',
    defaultMessage: 'Todo list is empty',
    description: 'Subtitle when there are no todos',
  },
  markedComplete: {
    id: 'KsMf/I1fVP',
    defaultMessage: 'Marked complete: {titles}',
    description: 'Subtitle listing todos marked complete',
  },
  removedTodos: {
    defaultMessage: 'Removed {count, plural, one {# todo} other {# todos}}',
    id: 'DrmxYvjOHZ',
    description: 'Subtitle showing how many todos were deleted',
  },
  updated: {
    id: 'Dk5dp9PS+P',
    defaultMessage: 'Updated: {titles}',
    description: 'Subtitle listing todos that were updated',
  },
  added: {
    id: 'nL2XuxhKr3',
    defaultMessage: 'Added: {titles}',
    description: 'Subtitle listing todos that were added',
  },
  titlesWithRemainder: {
    defaultMessage: '{titles} {count, plural, one {+# more} other {+# more}}',
    id: 'CYHO5K5IVe',
    description: 'Truncated todo title list with the number of hidden titles',
  },
  completedProgress: {
    id: 'eLRR5QNwnu',
    defaultMessage: '{completed}/{total} completed',
    description: 'Collapsed checklist progress summary',
  },
  planTitle: {
    defaultMessage: '<label>Plan:</label> {title}',
    id: 'tCK+q7catQ',
    description: 'Plan card header with a bold object label followed by the plan title',
  },
  planStepCount: {
    defaultMessage: '{count, plural, one {# step} other {# steps}}',
    id: 'tyh6KYZmoW',
    description: 'Step count at the trailing edge of a proposed plan card header',
  },
  planHeaderProgress: {
    defaultMessage: '{completed}/{total}',
    id: 'hOggjntR5p',
    description: 'Compact progress at the trailing edge of a running plan card header',
  },
  showPlanSteps: {
    id: 'ETlUWo24Xh',
    defaultMessage: 'Show plan steps',
    description: 'Screen-reader prefix on the pinned plan progress summary',
  },
  planDoneBadge: {
    id: 'MARREItHg7',
    defaultMessage: 'Done',
    description: 'Badge on a finished plan card',
  },
  planStoppedBadge: {
    id: 'VM37yTVj5r',
    defaultMessage: 'Stopped',
    description: 'Badge on a plan card whose turn failed',
  },
  planDeclinedBadge: {
    defaultMessage: 'Declined',
    id: 'vUn3aVEBp1',
    description: 'Badge on a plan card the clinician declined',
  },
  planStepsDone: {
    defaultMessage: '{count} done',
    id: 'cSDXAMSBCI',
    description:
      'Toggle row standing in for the completed steps folded at the top of the plan card',
  },
  planProgressSteps: {
    defaultMessage: '{completed}/{total} steps',
    id: 'j1Qd5KGYGD',
    description: 'Step count on the pinned plan progress summary',
  },
  showMorePlanSteps: {
    defaultMessage: 'Show {count} more',
    id: 'I/piCOv6Uo',
    description: 'Reveals additional rows in a long proposed plan',
  },
  showFewerPlanSteps: {
    defaultMessage: 'Show less',
    id: 'TQP7kI99A8',
    description: 'Hides additional rows in a long proposed plan',
  },
  startPlan: {
    defaultMessage: 'Start plan',
    id: '+C4Hc5nr6T',
    description: 'Primary action that accepts a proposed plan and starts its work',
  },
  declinePlan: {
    defaultMessage: 'Decline',
    id: 'K6XYSY6edF',
    description: 'Secondary action that rejects a proposed plan before it starts',
  },
});
